import { errorLogger } from '@ajaibid/utils';
import fetcher from '@helpers/fetcher';

function getUrl() {
  return 'v2/home/portfolio/';
}

/**
 * @param {string} url
 */
function callbackFetch(url) {
  return async () => {
    try {
      const res = await fetcher.get(url);
      return res.data;
    } catch (err) {
      errorLogger('ERROR_API', err.message);
      throw err;
    }
  };
}

export default function fetch() {
  const url = getUrl();

  return {
    cb: callbackFetch(url),
    key: [url],
  };
}
